module.exports = __webpack_public_path__ + "static/img/qc.d9dcf9d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qc.gif
// module id = EE5e
// module chunks = 2